import styled from '@emotion/styled'
import mq from 'theme/mediaQueries'

export const Container = styled.div`
  ${mq({
    display: ['block', 'block', 'grid'],
  })}

  grid-template-columns: 120px auto 100px;
`
